import React from "react";
import Modal from "react-modal";
import { useLanguage } from "../context/LanguageContext";
import { useUI } from "../constants/i18n";

interface InfoPopupProps {
  isOpen: boolean;
  onRequestClose: () => void;
}

const InfoPopup: React.FC<InfoPopupProps> = ({ isOpen, onRequestClose }) => {
  const { lang } = useLanguage();
  const ui = useUI(lang);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="bg-[#161616] p-8 shadow-lg max-w-md mx-auto mt-10"
      overlayClassName="fixed inset-0 bg-black bg-opacity-80"
      contentLabel="Information about Shubin Project"
      ariaHideApp={false}
    >
      <div className="flex justify-end">
        <button
          onClick={onRequestClose}
          className="bg-[#C1282DFF] hover:bg-[#606060] py-2 px-4"
          aria-label="Close dialog"
        >
          {ui.infoClose}
        </button>
      </div>
      <h2 className="text-2xl mb-4">{ui.infoTitle}</h2>
      <p className="mb-4">{ui.infoBody1}</p>
      <p className="mb-4">{ui.infoBody2}</p>
      <p className="mb-4">
        {ui.infoBody3}{" "}
        <a
          href="mailto:shubinproject@gmail.com"
          className="text-[#C1282DFF] underline"
        >
          shubinproject@gmail.com
        </a>
      </p>
    </Modal>
  );
};

export default InfoPopup;
